if ('scrollRestoration' in history) {
	history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);

if (typeof window.requestIdle === 'undefined') {
	window.requestIdle = window.requestIdleCallback || function(cb) { setTimeout(() => cb({ timeRemaining: () => 50 }), 1); };
}

if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	window.scrollTo(0, 0);



	document.addEventListener('DOMContentLoaded', (event) => {
		window.requestIdle(() => {

			let storybookIntroLottie, storybookOutroLottie;
			let storybook, contentTimeline;
			let storybookScrollTrigger, contentScrollTrigger;

			function initStorybook() {
				const mm = gsap.matchMedia();
				/**
				 * Storybook Parallax
				 */
				const storybookImage = document.querySelector('.storybook-image-1');
				const storybookImage4 = document.querySelector('.storybook-image-4');
				const storybookImage5 = document.querySelector('.storybook-image-5');

				if (storybookImage) {
					// Only load Lottie animations once
					if (!storybookIntroLottie) {
						storybookIntroLottie = lottie.loadAnimation({
							container: document.getElementById('storybookIntroLottie'),
							renderer: 'svg',
							loop: false,
							autoplay: false,
							path: themeData.sparkle01,
						});
					}
					if (!storybookOutroLottie) {
						storybookOutroLottie = lottie.loadAnimation({
							container: document.getElementById('storybookOutroLottie'),
							renderer: 'svg',
							loop: false,
							autoplay: false,
							path: themeData.sparkle02,
						});
					}

					const storybookComponent = document.querySelector('.storybook-component');
					const imagesLeft = document.querySelector('.storybook-images-left');
					const parallaxStrength = -85; // <-- Control how far to move here (in %)

					if (storybookComponent) {
						mm.add("(prefers-reduced-motion: no-preference)", () => {
							ScrollTrigger.create({
								trigger: storybookComponent,
								start: "top top",
								end: "bottom top",
								scrub: true,
								invalidateOnRefresh: true, // ✅ Needed for correct resizing!,
								onUpdate: (self) => {
									// Calculate based on scroll progress (0 to 1)
									const progress = self.progress;
									if (imagesLeft) {
										gsap.set(imagesLeft, {
											yPercent: progress * parallaxStrength
										});
									}
								},
							});
						});
					}

					const sideContent1 = document.querySelector('.side-content-1');
					const sideContent2 = document.querySelector('.side-content-2');
					const sideContent3 = document.querySelector('.side-content-3');

					if (sideContent1) {
						contentTimeline = gsap.timeline();
						contentScrollTrigger = ScrollTrigger.create({
							animation: contentTimeline,
							trigger: '.content-wrapper',
							start: 'top top',
							end: '+=150%',
							scrub: true,
							invalidateOnRefresh: true, // 🛠️ Add this line
						});

						mm.add("(prefers-reduced-motion: no-preference)", () => {
							contentTimeline.to(sideContent1, {autoAlpha: 0, y: -50, duration: 0.5});
							if (sideContent2) {
								contentTimeline
									.fromTo(
										sideContent2,
										{autoAlpha: 0, y: 50},
										{autoAlpha: 1, y: 0, duration: 0.5}
									)
									.to(
										sideContent2,
										{autoAlpha: 0, y: -50, duration: 0.5},
										'+=1'
									);
							}
							if (sideContent3) {
								contentTimeline.fromTo(
									sideContent3,
									{autoAlpha: 0, y: 50},
									{autoAlpha: 1, y: 0, duration: 0.5}
								);
							}
						});

						mm.add("(prefers-reduced-motion: reduce)", () => {
							contentTimeline.to(sideContent1, {autoAlpha: 0, duration: 0.5});
							if (sideContent2) {
								contentTimeline
									.fromTo(
										sideContent2,
										{autoAlpha: 0},
										{autoAlpha: 1, duration: 0.5}
									)
									.to(
										sideContent2,
										{autoAlpha: 0, duration: 0.5},
										'+=1'
									);
							}
							if (sideContent3) {
								contentTimeline.fromTo(
									sideContent3,
									{autoAlpha: 0},
									{autoAlpha: 1, duration: 0.5}
								);
							}
						});
					}
				}
			}

			// Initial load
			//initStorybook();
			/*
						// Rebuild ScrollTriggers on window resize
						let resizeTimeout;
						window.addEventListener('resize', () => {
							clearTimeout(resizeTimeout);
							resizeTimeout = setTimeout(() => {
								initStorybook(); // Rebuild animations
								storybook?.progress(0).pause(); // Reset storybook timeline
								ScrollTrigger.refresh(); // recalculate triggers
								ScrollTrigger.getAll().forEach(st => st.update()); // sync animations to scroll position
							}, 250);
						});
			*/
		}
	)
	}); // end requestIdle

	document.addEventListener("DOMContentLoaded", function () {
		window.requestIdle(() => {
		const mm = gsap.matchMedia();
		const storybookComponent = document.querySelector('.storybook-component');

		if (storybookComponent) {
			const fastElements = document.querySelectorAll('.storybook-images-fast');
			const mediumElements = document.querySelectorAll('.storybook-images-medium');
			const slowElements = document.querySelectorAll('.storybook-images-slow');

			const fastStrength = -85;
			const mediumStrength = -50;
			const slowStrength = -25;

			let componentTop = 0;
			let componentHeight = 0;
			let windowHeight = window.innerHeight;

			let targetProgress = 0;
			let currentProgress = 0;
			const smoothingFactor = 0.1;

			function updateMeasurements() {
				const rect = storybookComponent.getBoundingClientRect();
				componentTop = window.scrollY + rect.top;
				componentHeight = rect.height;
				windowHeight = window.innerHeight;
			}

			function updateTarget() {
				const scrollY = window.scrollY;
				const rawProgress = Math.min(Math.max((scrollY - componentTop) / (componentHeight - windowHeight), 0), 1);
				targetProgress = rawProgress * rawProgress; // Quadratic easing
			}

			function animate() {
				currentProgress += (targetProgress - currentProgress) * smoothingFactor;

				fastElements.forEach(el => {
					const yPercent = currentProgress * fastStrength;
					el.style.transform = `translateY(${yPercent}%)`;
				});

				mediumElements.forEach(el => {
					const yPercent = currentProgress * mediumStrength;
					el.style.transform = `translateY(${yPercent}%)`;
				});

				slowElements.forEach(el => {
					const yPercent = currentProgress * slowStrength;
					el.style.transform = `translateY(${yPercent}%)`;
				});

				requestAnimationFrame(animate);
			}

			mm.add("(prefers-reduced-motion: no-preference)", () => {
				updateMeasurements();
				updateTarget();
				animate();

				window.addEventListener('scroll', updateTarget);
				const resizeHandler = () => {
					updateMeasurements();
					updateTarget();
				};
				window.addEventListener('resize', resizeHandler);

				return () => { // Cleanup
					window.removeEventListener('scroll', updateTarget);
					window.removeEventListener('resize', resizeHandler);
					// Stop animation loop? 
					// Ideally we should cancelAnimationFrame but we don't store the ID.
					// But since we remove listeners, updateTarget won't fire, targetProgress freezes.
					// currentProgress will eventually equal targetProgress and it settles.
				};
			});

			const storybookIntroLottie = lottie.loadAnimation({
				container: document.getElementById('storybookIntroLottie'),
				renderer: 'svg',
				loop: false,
				autoplay: false,
				path: themeData.sparkle01,
			});
			const storybookOutroLottie = lottie.loadAnimation({
				container: document.getElementById('storybookOutroLottie'),
				renderer: 'svg',
				loop: false,
				autoplay: false,
				path: themeData.sparkle02,
			});

			function playIntro() {
				storybookIntroLottie.goToAndPlay(0);
			}

			function playOutro() {
				storybookOutroLottie.goToAndPlay(0);
			}

			const storybookScrollTrigger = ScrollTrigger.create({
				trigger: '.storybook-component',
				start: 'top top',
				end: "bottom 50%",
				onEnter: playIntro,
				onEnterBack: playOutro,
				onLeave: playOutro,
				onLeaveBack: playIntro
			});
		}

		const sideContent1 = document.querySelector('.side-content-1');
		const sideContent2 = document.querySelector('.side-content-2');
		const sideContent3 = document.querySelector('.side-content-3');

		if (sideContent1) {
			const contentTimeline = gsap.timeline();
			const contentScrollTrigger = ScrollTrigger.create({
				animation: contentTimeline,
				trigger: '.storybook-component',
				start: 'top top',
				end: "bottom 50%",
				scrub: true,
				invalidateOnRefresh: true, // 🛠️ Add this line
			});

			mm.add("(prefers-reduced-motion: no-preference)", () => {
				contentTimeline.to(sideContent1, {autoAlpha: 0, y: -50, duration: 0.5});
				if (sideContent2) {
					contentTimeline
						.fromTo(
							sideContent2,
							{autoAlpha: 0, y: 50},
							{autoAlpha: 1, y: 0, duration: 0.5}
						)
						.to(
							sideContent2,
							{autoAlpha: 0, y: -50, duration: 0.5},
							'+=1'
						);
				}
				if (sideContent3) {
					contentTimeline
						.fromTo(
							sideContent3,
							{autoAlpha: 0, y: 50},
							{autoAlpha: 1, y: 0, duration: 0.5}
						)
						.to(
							sideContent3,
							{autoAlpha: 1, y: 0, duration: 0.5}, // Maintain visibility
							'+=0.5' // <-- 👈 this holds it visible for an extra "time"
						);
				}
			});
			mm.add("(prefers-reduced-motion: reduce)", () => {
				contentTimeline.to(sideContent1, {autoAlpha: 0, duration: 0.5});
				if (sideContent2) {
					contentTimeline
						.fromTo(
							sideContent2,
							{autoAlpha: 0},
							{autoAlpha: 1, duration: 0.5}
						)
						.to(
							sideContent2,
							{autoAlpha: 0, duration: 0.5},
							'+=1'
						);
				}
				if (sideContent3) {
					contentTimeline
						.fromTo(
							sideContent3,
							{autoAlpha: 0},
							{autoAlpha: 1, duration: 0.5}
						)
						.to(
							sideContent3,
							{autoAlpha: 1, duration: 0.5}, // Maintain visibility
							'+=0.5' 
						);
				}
			});
		}
	});
		ScrollTrigger.refresh();
	}); // end requestIdle